import { connect } from "react-redux";
import TeeDeck from "pages/secure/facility/settings/facility/TeeDeck";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {
    facilityStore: { ...state.facilityStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeeDeck);
